import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { clearToken, getCurrentUser } from "../lib/auth";
import { api } from "../lib/api";

interface Props {
  activeTab?: "spaces" | "agents" | "reviews" | "profile";
}

export default function GlobalHeader({ activeTab }: Props) {
  const navigate = useNavigate();
  const user = getCurrentUser<{ sub: string; username: string; email: string }>();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    api.get<{ id: string }[]>("/api/pending-reviews")
      .then((items) => setPendingCount(items.length))
      .catch(() => {});
  }, []);

  function handleSignOut() {
    clearToken();
    navigate("/", { replace: true });
  }

  const base = "text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors";
  const active = "text-sm text-blue-600 dark:text-blue-400 font-medium";

  return (
    <header className="shrink-0 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-6 py-3 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <Link to="/" className="text-base font-bold text-gray-900 dark:text-gray-100">
          Agent Wiki
        </Link>
        <nav className="flex items-center gap-4">
          <Link to="/dashboard" className={activeTab === "spaces" ? active : base}>Spaces</Link>
          <Link to="/agents" className={activeTab === "agents" ? active : base}>Agents</Link>
          <Link to="/reviews" className={`flex items-center gap-1.5 ${activeTab === "reviews" ? active : base}`}>
            Reviews
            {pendingCount > 0 && (
              <span className="inline-flex items-center justify-center w-5 h-5 text-xs font-bold rounded-full bg-orange-500 text-white">
                {pendingCount}
              </span>
            )}
          </Link>
          <Link to="/profile" className={activeTab === "profile" ? active : base}>Profile</Link>
        </nav>
      </div>
      <div className="flex items-center gap-4">
        {user && (
          <span className="text-sm text-gray-600 dark:text-gray-400">{user.username ?? user.email}</span>
        )}
        <button
          onClick={handleSignOut}
          className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
